import { defineComponent as r, useSlots as c, openBlock as a, createBlock as u, unref as t, mergeProps as m, withCtx as p, createElementVNode as i, createElementBlock as s, renderSlot as n, createCommentVNode as d, createVNode as f } from "vue";
import "./ghl-ui.es368.js";
import h from "./ghl-ui.es369.js";
import v from "./ghl-ui.es190.js";
const b = { class: "hl-radio-group-item-container" }, B = {
  key: 0,
  class: "hl-radio-group-item-icon"
}, g = {
  key: 1,
  class: "hl-radio-group-item-content"
}, N = { class: "hl-radio-group-item-action" }, _ = r({
  name: "UIRadioButton",
  inheritAttrs: !1
}), k = r({
  ..._,
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Number, Boolean]
    },
    compact: Boolean
  },
  setup(e) {
    const l = c();
    return (o, y) => (a(), u(t(h), m(o.$attrs, {
      value: e.value,
      disabled: e.disabled,
      class: ["hl-radio-group-item", e.compact ? "compact-radio-item" : null]
    }), {
      default: p(() => [
        i("div", b, [
          t(l).icon ? (a(), s("div", B, [
            n(o.$slots, "icon")
          ])) : d("", !0),
          t(l).content ? (a(), s("div", g, [
            n(o.$slots, "content")
          ])) : d("", !0),
          i("div", N, [
            f(t(v), {
              value: e.value,
              disabled: e.disabled
            }, null, 8, ["value", "disabled"])
          ])
        ])
      ]),
      _: 3
    }, 16, ["value", "disabled", "class"]));
  }
}), V = k;
export {
  V as default
};
